
  import { Component, PropSync, Vue, Emit } from "vue-property-decorator";
  import { mcLabels, MealCountDtoViewModel } from '@/view-models';
  import { ServingLine } from '@/models';
  import { mcLogger } from '@/utils';
  import moment from 'moment';

  @Component
  export default class McWaste extends Vue {
    @PropSync("mealCounts", { type: Object }) mealCountsSync!: MealCountDtoViewModel;
    private console: Console = mcLogger.getConsole(this.constructor.name, 'orange')
    labels = mcLabels.mealCounts.waste;

    @Emit('input-changed')
    inputChanged() {
      const date = moment.utc().format();
      this.mealCountsSync.mealCounts.versionDateTimeUtc = date;
      let userServingLine = this.mealCountsSync.userServingLine;
      if (userServingLine) {
        userServingLine.modifiedDateTimeUtc = date;
      }

      return this.mealCountsSync.mealType;
     }

    //TODO: This is repeated in mc-serve, can we put it somewhere central?
    get servingLineSummaries(): ServingLine[] {
      let result: ServingLine[] = [];
      if (this.mealCountsSync) {
        result = this.mealCountsSync.nonUserServingLines;
      }
      return result;
    }
  }
